import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import { attemptToConvertExternalOptionsFilter, isOperatorIncompatibleWithExternalOptionsField } from '../utils/externalOptionsConversionUtils';
import { useStrategy } from './useStrategy';
import { useOperatorOptions } from './useOperatorOptions';
export const useConditionInputs = props => {
  const {
    condition,
    disabled,
    filterFamily,
    onConditionOperatorChange,
    onConditionValueChange,
    isRefinement = false,
    isRefinementEnabled = false
  } = props;
  const {
    getOperatorsForType
  } = useStrategy();
  const {
    getIsUngated,
    getTrackerInstance,
    props: {
      baseFilterFamily,
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    options: operatorOptions,
    getOperatorByName
  } = useOperatorOptions(filterFamily, condition);
  const isOperatorIncompatible = isOperatorIncompatibleWithExternalOptionsField(condition, filterFamily, getOperatorsForType, getIsUngated);
  const canFilterBeConverted = isOperatorIncompatible && attemptToConvertExternalOptionsFilter(condition) !== undefined;
  const isRefinementDisabled = isRefinement && !isRefinementEnabled;
  const disableOperatorSelection = disabled || isOperatorIncompatible || isRefinementDisabled;
  const disableValueInput = disabled || isRefinementDisabled;
  const onSelectedOptionChange = evt => {
    var _getTrackerInstance, _condition$field, _condition$field2;
    const operatorName = evt.target.value.value;
    onConditionOperatorChange(getOperatorByName(operatorName));
    (_getTrackerInstance = getTrackerInstance()) === null || _getTrackerInstance === void 0 || _getTrackerInstance.track('changedFilterOperator', {
      operator: operatorName,
      primaryObjectTypeId: baseFilterFamily,
      property: (_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.name,
      type: (_condition$field2 = condition.field) === null || _condition$field2 === void 0 ? void 0 : _condition$field2.type,
      version: useOnePanel ? '2' : '1'
    });
  };
  const handleUpdateClick = () => {
    if (!condition.field) {
      return;
    }
    const newCondition = attemptToConvertExternalOptionsFilter(condition);
    if (newCondition) {
      onConditionValueChange(newCondition);
    }
  };
  return {
    canFilterBeConverted,
    disableOperatorSelection,
    disableValueInput,
    handleUpdateClick,
    isOperatorIncompatible,
    onSelectedOptionChange,
    operatorOptions
  };
};